import {Controller} from "stimulus";

export default class extends Controller {
    static targets = ["search"]

    searchTable() {
        let element = this.element.querySelector('[data-id="search-organization"]');
        if (element == undefined) {
            element = this.element.querySelector('[data-id="search-vendor-bills"]');
        }
        let searchParam = element.value;
        let searchTargets = document.querySelectorAll('[data-search-target]')
        if (searchParam === '') {
            removeClassForItems(searchTargets)
        } else {
            addClassForItems(searchTargets)
            return searchTargets.forEach((item) => {
                if (item.attributes['data-search-target'].nodeValue.toLowerCase().search(searchParam.toLowerCase()) >= 0) {
                    return item.classList.remove('is-hidden');
                }
            })
        }
    }
}

function addClassForItems(items, className = 'is-hidden') {
    items.forEach((item) => item.classList.add(className))
}

function removeClassForItems(items, className = 'is-hidden') {
    items.forEach((item) => item.classList.remove(className))
}